import React from 'react';
import glamorous from 'glamorous';
import FaPencil from 'react-icons/lib/ti/pencil';
import FaTrash from 'react-icons/lib/ti/trash';
import User from 'react-icons/lib/ti/user-outline';
import moment from "moment";

const TIME_FORMAT = "HH:mm";
const DATE_FORMAT = "M/D/YY";

const ActionCellRenderer = (props) => {
  const { original } = props;
  const { actionHandler } = props.columnProps.rest;
  const linkStyle = {textDecoration: 'underline', color: '#acb5be', fontSize: 12};
  const markerStyle = {margin: '0 20 0 2', fontSize: 18};

  const activeText = original.status === 'Disabled' ? 'Mark Active' : 'Mark Inactive';
  const actionText = original.status === 'Disabled' ? 'UNBLOCK' : 'BLOCK';

  return (
    <glamorous.Div 
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'space-around',
        fontWeight: 400,
        fontStyle: 'italic',          
      }}> 
      <p><a style={linkStyle} onClick={() => actionHandler(actionText, {...props.original, rowID: props.index})}>{activeText}<User style={markerStyle}/></a></p>    
      <p><a style={linkStyle} onClick={() => actionHandler('UPDATE', {...props.original, rowID: props.index})}>Edit User <FaPencil style={markerStyle}/></a></p>    
      <p><a style={linkStyle} onClick={() => actionHandler('DELETE', {...props.original, rowID: props.index})}>Delete User <FaTrash style={markerStyle}/></a></p>  
    </glamorous.Div>
  );
}

const StatusCellRenderer = (props) => {
  const { original } = props;
  const { actionHandler } = props.columnProps.rest;
  const linkStyle = {textDecoration: 'underline', color: '#acb5be', fontSize: 12};
  const LinkText = original.status === 'Invitation Sent' ? '(Resend)' : '';

  let color;
  switch(original.status) {
    case 'Active': 
      color = 'green';
      break;
    case 'Disabled': 
      color = 'red';
      break;
    case 'Invitation Sent': 
      color = 'black';
      break;
    case 'Invitation Expired': 
      color = 'red';
      break;
    default:
      color = 'black';
      break;
  }

  const statusStyle = {color: color, fontSize: 12};
  
  return (
    <glamorous.Div 
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'space-around',
        fontWeight: 400       
      }}> 
      <p style={statusStyle}>{original.status}<a style={linkStyle} onClick={() => actionHandler('RESEND', {...props.original, rowID: props.index})}>{LinkText}</a></p>    
    </glamorous.Div>
  );
}

const LastLoginCellRenderer = (props) => {
  const { time, date } = props.value;

  if (date == null) {
    return null;
  }

  return (
    <glamorous.Div css={{display: 'flex', flexDirection: 'column'}}>
      <div>{`${time}`}</div>
      <div>{`${date}`}</div>
    </glamorous.Div>
  );
}

export const getColumns = (actionHandler) => {

  return [
    {
      Header: "Email",
      accessor: "email",
      minWidth: 250,
      style: {
        minWidth: 250,
        display: 'flex'
      }
    },
    {
      Header: "Role",
      accessor: "role",
      minWidth: 200,
      style: {
        minWidth: 200,
        display: 'flex'
      }
    },
    {
      Header: "Status",
      id: 'statusCell',
      minWidth: 100,
      style: {
        minWidth: 100,
        display: 'flex'
      },
      Cell: StatusCellRenderer,
      getProps: () => {return { actionHandler }}
    },
    {
      Header: 'Last Login',
      id: 'lastLogin',
      //accessor: "last_login",
      minWidth: 200,
      style: {
        minWidth: 200,
        display: 'flex'
      },
      Cell: LastLoginCellRenderer,
      accessor: d => { return {
        time: d.last_login ? moment(d.last_login).format(TIME_FORMAT) : '', 
        date: d.last_login ? moment(d.last_login).format(DATE_FORMAT) : ''
      }}
    },
    {
      Header: "# of Logins",
      accessor: "logins_count",
      minWidth: 100,
      style: {
        minWidth: 100,
        display: 'flex'
      }
    },
    {
      Header: "Actions",
      id: 'actionCell',
      minWidth: 350,
      style: {
        minWidth: 350,
        display: 'flex',
        justifyContent: 'center'
      },
      Cell: ActionCellRenderer,      
      getProps: () => {return { actionHandler }}
    }
  ];
};


// WEBPACK FOOTER //
// ./src/modules/users/UsersColumns.js